import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InventoryItemFeature } from '@contracts/interfaces/inventory-item.interface';

export interface DialogData {
  itemFeature: InventoryItemFeature,
  itemFeatureValue: string
}

@Component({
  selector: 'app-dialog-inventory-item-feature',
  templateUrl: 'inventory-item-feature.dialog.html',
  styleUrls: ['./inventory-item-feature.dialog.scss']
})
export class InventoryItemFeatureDialogComponent {

  public itemFeature: any = {
    label: "",
    type: "custom"
  }

  public itemFeatureValue = "";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<InventoryItemFeatureDialogComponent>
    ) {
      if (this.data.itemFeature != undefined) {
        this.itemFeature = this.data.itemFeature;
      }

      this.itemFeatureValue = this.data.itemFeatureValue;
    }

  ngOnInit() {


  }

  delete() {
    this.dialogRef.close("delete");
  }

  save () {
    this.dialogRef.close({
      itemFeature: this.itemFeature, 
      itemFeatureValue: this.itemFeatureValue
    });
  }
}
